import { gql } from '@apollo/client'

export const GET_TAG_COMMANDER_VARS = gql`
  query TcVars {
    tcVars
  }
`
